module.exports = __webpack_public_path__ + "static/media/005.66b9146a.jpg";